import React, { useState, useEffect } from 'react'

const Image = ({
    motion, image, animate
}) => {
    const [newImage, setImage] = useState(image);
    useEffect(() => {
        if (newImage !== image) {
            setImage(image);
        }
    }, [newImage, image])
    if (newImage === image) {
        return <motion.img animate={animate} transition={{ duration: .6 }} src={image} alt="" />
    }
    return null;
}

export default Image
